/* unplugin-vue-components disabled */import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__